// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".global-message{margin:0 auto 2rem auto;width:68rem;padding:1rem 2rem;font-size:1rem;color:#9b9b9b;background:#fff;box-shadow:0 .25rem .625rem 0 rgba(0,0,0,.07);box-sizing:border-box}.global-message *{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
